export const INTERSTATE_TERMINAL_ID = 2;
export const VAN_G_FOWLER_TERMINAL_ID = 43;
// Cando Rail & Terminals (Stockton) — the former Savage Stockton facility.
export const CANDO_TERMINAL_ID = 47;
export const MHX_TERMINAL_ID = 31;
export const USDG_SAN_BERNARDINO_ID = 56;
export const SAN_YSIDRO_TRANSLOAD_ID = 11;

export const ingestedTerminalIds = [
	INTERSTATE_TERMINAL_ID,
	VAN_G_FOWLER_TERMINAL_ID,
	CANDO_TERMINAL_ID,
	MHX_TERMINAL_ID,
	USDG_SAN_BERNARDINO_ID,
	SAN_YSIDRO_TRANSLOAD_ID,
];
